import api from "./Api";
import { BASE_URL } from "./Context/config";

export interface CardPurchaseRequest {
  email: string;
  phone: string;
}

export const SubmitCardPurchaseRequest = async (
  request: CardPurchaseRequest
) => {
  try {
    const response = await api.post(
      `${BASE_URL}/CardPurchase/Request`,
      request,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error submitting card purchase request:", error);
    if (error.response && error.response.data) {
      if (typeof error.response.data === "string") {
        throw new Error(error.response.data);
      } else if (error.response.data.message) {
        throw new Error(error.response.data.message);
      } else {
        throw new Error("An error occurred while submitting the request.");
      }
    } else {
      throw new Error("Network error. Please try again.");
    }
  }
};
